import CardNetworkSelectorField from '@/components/config-editor/components/fields/CardNetworkSelectorField';
import SectionsField from '@/components/config-editor/components/fields/SectionsField';
import SwitchField from '@/components/config-editor/components/fields/SwitchField';
import TranslationField from '@/components/config-editor/components/fields/TranslationField';
import { CheckboxWidget } from '@/components/config-editor/components/widgets/CheckboxWidget';
import IconSelectorWidget from '@/components/config-editor/components/widgets/IconSelector';
import ImageWidget from '@/components/config-editor/components/widgets/Image';
import VideoWidget from '@/components/config-editor/components/widgets/Video';
import OfferSelectorWidget from '@/components/config-editor/components/widgets/OfferSelector';
import OrderBumpSelectorWidget from '@/components/config-editor/components/widgets/OrderBumpSelector';
import PriceSelectorWidget from '@/components/config-editor/components/widgets/PriceSelector';
import StoreConfigImageWidget from '@/components/config-editor/components/widgets/StoreConfigImage';
import StoreConfigString from '@/components/config-editor/components/widgets/StoreConfigString';
import SwitchWidget from '@/components/config-editor/components/widgets/SwitchWidget';
import VariantSelectorWidget from '@/components/config-editor/components/widgets/VariantSelector';
import type { RegistryFieldsType, RegistryWidgetsType } from '@rjsf/utils';

export const widgets: RegistryWidgetsType = {
  priceSelector: PriceSelectorWidget,
  orderBumpSelector: OrderBumpSelectorWidget,
  variantSelector: VariantSelectorWidget,
  storeConfigImage: StoreConfigImageWidget,
  image: ImageWidget,
  video: VideoWidget,
  storeConfigString: StoreConfigString,
  offerSelector: OfferSelectorWidget,
  iconSelector: IconSelectorWidget,
  toggleSwitch: SwitchWidget,
  CheckboxWidget,
};

export const fields: RegistryFieldsType = {
  translation: TranslationField,
  section: SectionsField,
  toggleSwitch: SwitchField,
  cardNetworkSelector: CardNetworkSelectorField,
};
